module.exports = __webpack_public_path__ + "static/media/grup_banner.2df8d3a2.svg";